<script setup>
import draggable from 'vuedraggable'
import {
  computed,
} from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import {
  KkIcon,
  KkLoading
} from '../../../../components/base'

const props = defineProps({
  imageValue: {
    type: Object,
    default: () => {}
  },
  movieValue: {
    type: Object,
    default: () => {}
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const store = useStore()
const { t } = useI18n()
const post = computed(() => store.getters['companiesStoreSnsPosts/post'])
const mediaLoading = computed(() => store.getters['companiesStoreSnsPosts/mediaLoading'])
const deletePostImage = (id) => store.dispatch('companiesStoreSnsPosts/deletePostImage', id)
const deletePostMovie = () => store.dispatch('companiesStoreSnsPosts/deletePostMovie')

const loading = computed(() => mediaLoading.value)
const emit = defineEmits(['update:imageValue', 'update:movieValue'])

const acceptType = computed(() => {
  if (post.value.images.length) {
    return 'image/*'
  }
  return 'image/*, video/*'
})

const handleChange = async ($event) => {
  const media = $event.target.files[0]

  const mimeType = media.type.split('/')[0]
  let mediaPayload = {
    url: '',
    width: '',
    height: '',
    fileName: '',
    content: '',
    time: ''
  }
  mediaPayload.fileName = media.name
  mediaPayload.url = URL.createObjectURL(media)
  switch(mimeType) {
  case 'image': {
    emit('update:imageValue', $event)
    break
  }
  case 'video': {
    emit('update:movieValue', $event)
    break
  }
  default:
    break
  }
}
const removePhoto = (id) => {
  deletePostImage(id)
}
const removeMovie = () => {
  deletePostMovie()
}
</script>

<template>
  <div class="upload-media">
    <div v-show="loading" class="upload-media__wrapper loading" :class="{ selected: post.images.length || post.movie}">
      <KkLoading />
    </div>

    <div v-show="!loading" class="upload-media__wrapper" :class="{ selected: post.images.length || post.movie }">
      <draggable v-if="post.images.length" v-model="post.images" item-key="id">
        <template #item="{element}">
          <div class="upload-media__content">
            <KkIcon name="draggable" color="rgba(58, 59, 63, 0.7)" class="upload-media__draggable" />
            <img :src="element.url" :alt="element.fileName" class="upload-media__image">
            <div class="upload-media__size">
              {{ element.width }}×{{ element.height }}
            </div>
            <button class="upload-media__icon" type="button" @click="removePhoto(element.id)">
              <KkIcon name="delete" color="rgba(58, 59, 63, 0.7)" />
            </button>
          </div>
        </template>
      </draggable>
      <div v-if="post.movie" class="upload-media__content">
        <video ref="video" :src="post.movie.url" muted class="upload-media__image" />
        <div class="upload-media__size">
          {{ post.movie.time }}
        </div>
        <button class="upload-media__icon" type="button" @click="removeMovie()">
          <KkIcon name="delete" color="rgba(58, 59, 63, 0.7)" />
        </button>
      </div>
    </div>
    <div v-if="!props.disabled" class="c-button c-button--icon">
      <label class="c-button__item c-button__item--primary">
        <input
          ref="file"
          type="file"
          class="u-hidden"
          :accept="acceptType"
          :disabled="props.disabled"
          @change="handleChange"
          @click="(e) => { e.target.value = '' }"
        >
        <KkIcon name="add" color="#E9446A" class="c-button__icon" />
        {{ t('components.PostImage.selectImage') }}
      </label>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .upload-media__wrapper {
    overflow: scroll hidden;
  }
}
.upload-media {
  .c-button {
    margin: 0;
  }
  &__wrapper {
    width: 100%;
    height: 328px;
    padding: 24px;
    background-color: rgba(245, 245, 245, 0.5);
    border: 1px solid #E4E7EB;
    border-radius: 4px;
    overflow-y: scroll;
    &.loading {
      display: block;
    }
    &.selected {
      background-color: #ffffff;
    }
  }
  &__content {
    margin-top: 8px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 64px;
    width: 100%;
    padding: 12px;
    border: 1px solid #E4E7EB;
    border-radius: 4px;
    &:first-child {
      margin-top: 0;
    }
    .c-button {
      margin: 0;
    }
    .c-button__item {
      padding: 0;
    }
  }
  &__image {
    display: block;
    object-fit: contain;
    width: 48px;
    height: 48px;
    border-radius: 4px;
    border: 1px solid #E3E3E3;
  }
  &__size {
    font-size: 14px;
    margin-left: 16px;
  }
  &__icon {
    width: 16px;
    margin-left: auto;
  }
  &__draggable {
    width: 10px;
    margin-right: 16px;
  }
}
:deep(.info__text) {
  white-space: unset;
}
.infoContainer {
  margin: 16px 0;
}
</style>
